export { ScrollArea } from "@mantine/core";
export type { ScrollAreaProps } from "@mantine/core";

export { scrollAreaOverrides } from "./ScrollArea.config";
